import { Destination } from '../../../../resources/destination/domain/types/destination';
import { Newsletter } from '../../../../shared/components/Newsletter/Newsletter';
import { SUBSCRIBE_MODE_FOOTER } from '../../../../shared/components/Newsletter/NewsletterService';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';

type Props = {
    destination?: PickDomain<Destination, 'slug'>;
    obfuscateLinks?: boolean;
};

export function FooterNewsletter({ destination, obfuscateLinks = true }: Props) {
    return (
        <Newsletter
            obfuscateFooterNewsletterLinks={obfuscateLinks}
            theme="green"
            subscribeMode={SUBSCRIBE_MODE_FOOTER}
            acquisitionTags={[`${SUBSCRIBE_MODE_FOOTER}`]}
            destination={destination}
            trackingInformation={{ subscription: { block: 'footer' } }}
        />
    );
}
